import React, { useState } from 'react'

// mui
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Box, Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography, Accordion, AccordionSummary, AccordionDetails, Select, MenuItem } from '@mui/material';
import { DataGrid, GridSelectionModel, GridToolbarContainer, GridToolbarExport, GridToolbarFilterButton, GridToolbarColumnsButton } from '@mui/x-data-grid';

import { useAppSelector, useAppDispatch } from '../../../hooks'
import { bulkAcceptCampaignAmbassadors, bulkDeclineCampaignAmbassadors, bulkWaitingCampaignAmbassadors, bulkRemoveCampaignAmbassadors, getFundraisingCampaignAmbassadors, setSelectedCampaignUpdate } from '../../../managers/redux/slices/fundraising'

import ManageCampaignUpdate from '../../../components/dialogs/fundraising/ManageCampaignUpdate';

import { FundraisingCampaignAmbassadorContact, FundraisingCampaignType, FollowUpResponse, FundraisingCampaignAmbassador, FundraisingCampaignUpdate, FundraisingCampaignAmbassadorStatus } from '../../../API'
import AddCampaignAmbassadorDialog from '../../../components/dialogs/fundraising/AddCampaignAmbassador';
import { API } from 'aws-amplify';
import { updateFundraisingCampaignAmbassador } from '../../../managers/graphql/mutations';
import { COLORS } from '../../../theme/muiTheme';
import { setLoading } from '../../../managers/redux/slices/loading';
import { toast } from 'react-toastify';
import axios from 'axios';

export default function Notifications(props: any) {

    const dispatch = useAppDispatch()

    const [showManageCampaignUpdateDialog, setShowManageCampaignUpdateDialog] = useState<boolean>(false)

    const selectedFundraisingCampaign = useAppSelector(state => state.fundraising.selectedCampaign)
    const selectedFundraisingCampaignAmbassadors = useAppSelector(state => state.fundraising.selectedCampaignAmbassadors)
    const selectedStaffProfile = useAppSelector(state => state.authAccount.selectedStaffProfile)
    const authAccount = useAppSelector(state => state.authAccount)
    const fundraising = useAppSelector(state => state.fundraising)

    const [showRemoveCampaignAmbassadorAlert, setShowRemoveCampaignAmbassadorAlert] = useState<boolean>(false)

    const [selectedRows, setSelectedRows] = useState<GridSelectionModel>([])

    const [massNotificationTitle, setMassNotificationTitle] = useState<string>('')
    const [massNotificationBody, setMassNotificationBody] = useState<string>('')
    const [sendMassNotificationPushNotification, setSendMassNotificationPushNotification] = useState<boolean>(false)
    const [sendMassNotificationSMS, setSendMassNotificationSMS] = useState<boolean>(false)
    const [sendMassNotificationToStatus, setSendMassNotificationToStatus] = useState<FundraisingCampaignAmbassadorStatus>(FundraisingCampaignAmbassadorStatus.Accepted)

    return (
        <div className="container-fluid p-0">
            <div className="row mx-5">
                <Accordion className="col-12 g-0 row border rounded bg-light p-3">
                    <AccordionSummary expandIcon={<ExpandMoreIcon />} className="col-12">
                        <div>
                            <Typography variant="h3">Send mass notification</Typography>
                        </div>
                    </AccordionSummary>
                    <AccordionDetails>
                        <div className="col-12 my-1">
                            <TextField variant="outlined" label="Title" fullWidth value={massNotificationTitle} onChange={(e) => setMassNotificationTitle(e.target.value)} />
                        </div>
                        <div className="col-12 my-1">
                            <TextField multiline minRows={3} variant="outlined" label="Body" fullWidth value={massNotificationBody} onChange={(e) => setMassNotificationBody(e.target.value)} />
                        </div>
                        <div className="col-12 d-flex flex-row justify-content-start align-items-center my-1">
                            <FormControlLabel checked={sendMassNotificationPushNotification} onChange={(e, checked) => setSendMassNotificationPushNotification(checked)} control={<Switch />} label="Send as Push Notification" />
                            <FormControlLabel checked={sendMassNotificationSMS} onChange={(e, checked) => setSendMassNotificationSMS(checked)} control={<Switch />} label="Send as SMS" />
                        </div>
                        <div className="col-12 d-flex flex-row justify-content-start align-items-center my-1">
                            <Typography className="me-3">Send to Ambassadors with status: </Typography>
                            <Select label="Send to Ambassadors with status" value={sendMassNotificationToStatus} onChange={(e) => setSendMassNotificationToStatus(e.target.value as FundraisingCampaignAmbassadorStatus)}>
                                <MenuItem value={FundraisingCampaignAmbassadorStatus.Connected}>Connected</MenuItem>
                                <MenuItem value={FundraisingCampaignAmbassadorStatus.Waiting}>Waiting</MenuItem>
                                <MenuItem value={FundraisingCampaignAmbassadorStatus.Accepted}>Accepted</MenuItem>
                                <MenuItem value={FundraisingCampaignAmbassadorStatus.Declined}>Declined</MenuItem>
                            </Select>
                        </div>
                        <div className="col-12 my-1">
                            <Button variant="contained" className="px-4" onClick={async () => {
                                dispatch(setLoading({ loading: true, message: '' }))
                                try {

                                    if (selectedFundraisingCampaignAmbassadors) {
                                        const scheduledNotifications: any[] = selectedFundraisingCampaignAmbassadors.map((fundraisingCampaignAmbassador: FundraisingCampaignAmbassador) => {
                                            if (fundraisingCampaignAmbassador.status == sendMassNotificationToStatus) {
                                                return {
                                                    timestamp: new Date(),
                                                    type: sendMassNotificationPushNotification && !sendMassNotificationSMS ? 'LatentPushNotification' : sendMassNotificationSMS && !sendMassNotificationPushNotification ? 'LatentSMSMessage' : sendMassNotificationPushNotification && sendMassNotificationSMS ? 'LatentPushSMSMessage' : undefined,
                                                    authAccountID: fundraisingCampaignAmbassador.fundraisingProfile?.authAccountID,
                                                    metadata: {
                                                        phoneNumber: sendMassNotificationSMS ? fundraisingCampaignAmbassador.fundraisingProfile?.authAccount?.phoneNumber : undefined,
                                                        smsBody: sendMassNotificationSMS ? `${massNotificationTitle} - ${massNotificationBody}` : undefined,
                                                        pushNotificationTitle: sendMassNotificationPushNotification ? massNotificationTitle : undefined,
                                                        pushNotificationBody: sendMassNotificationPushNotification ? massNotificationBody : undefined
                                                    }
                                                }
                                            } else return undefined
                                        })
                                        console.log(scheduledNotifications)
                                        const response = await axios.post('https://3vkykmueb3.execute-api.us-east-2.amazonaws.com/v1/notifications/scheduled-notification', {
                                            scheduledNotifications
                                        }, {
                                            headers: {
                                                'x-api-key': 'saDCWwYMSU8OaSyI1cDhs7Dabr1GArEk4uSYC7fl'
                                            }
                                        })
                                        console.log(response)
                                    } else {
                                        toast.error('There are no Ambassadors for the selected Campaign.', { containerId: 'main' })
                                    }

                                    dispatch(setLoading({ loading: false, message: '' }))
                                } catch (err) {
                                    console.log(JSON.stringify(err))
                                    dispatch(setLoading({ loading: false, message: '' }))
                                }
                            }}>Send Notification</Button>
                        </div>
                    </AccordionDetails>
                </Accordion>
                <div className="col-12">
                    <Button variant="contained" className="my-3 px-4"
                        onClick={() => {
                            setShowManageCampaignUpdateDialog(true)
                        }}
                    >Add an update</Button>
                </div>
                <div className="col-12">
                    <TableContainer component={Paper}>
                        <Table sx={{ minWidth: 650 }} aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell align="left">Live</TableCell>
                                    <TableCell align="left">Created on</TableCell>
                                    <TableCell align="left">Visible to</TableCell>
                                    <TableCell align="left">Message</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {
                                    fundraising && fundraising.selectedCampaignUpdates && fundraising.selectedCampaignUpdates.length > 0 ?
                                        fundraising.selectedCampaignUpdates.map((fundraisingCampaignUpdate: FundraisingCampaignUpdate) => {
                                            if (fundraisingCampaignUpdate) {
                                                return (
                                                    <TableRow
                                                        key={fundraisingCampaignUpdate.id}
                                                        sx={{ '&:last-child td, &:last-child th': { border: 0 }, cursor: 'pointer', ':hover': { backgroundColor: COLORS.ICE } }}
                                                        onClick={() => {
                                                            setShowManageCampaignUpdateDialog(true)
                                                            dispatch(setSelectedCampaignUpdate({ campaignUpdate: fundraisingCampaignUpdate }))
                                                        }}
                                                    >
                                                        <TableCell align="left">
                                                            {fundraisingCampaignUpdate.live ? 'Yes' : 'No'}
                                                        </TableCell>
                                                        <TableCell align="left">
                                                            {fundraisingCampaignUpdate.createdAt ? new Date(fundraisingCampaignUpdate.createdAt).toLocaleDateString() : 'Not added'}
                                                        </TableCell>
                                                        <TableCell align="left">
                                                            {fundraisingCampaignUpdate.public ? 'Everyone' : 'Ambassadors only'}
                                                        </TableCell>
                                                        <TableCell align="left">
                                                            {fundraisingCampaignUpdate.message ? fundraisingCampaignUpdate.message.substring(0, 50) : 'Not added'}
                                                        </TableCell>
                                                    </TableRow>
                                                )
                                            }
                                        })
                                        :
                                        <div></div>
                                }
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>
            </div>

            <ManageCampaignUpdate visible={showManageCampaignUpdateDialog} onClose={() => setShowManageCampaignUpdateDialog(false)} />
        </div>
    )
}